import i18n
	from '../i18n/i18n'

export default class full {
	constructor() {
		this.language = i18n.language.substr(0, 2)
		this.characters = [];
		const languages = {
			de: require('../data/de/euro.json'),
			en: require('../data/en/euro.json')
		};
		this.characters = languages[this.language]
	}

	getCategories() {
		let categories = this.characters.systems.euro.categories;
		delete categories.control;
		return categories;
	}

	getCharactersByCategory(category) {
		var result = {};
		var count = 0
		for (let key in this.characters.systems.euro.categories) {
			if (category !== '0') {
				if (key === category.toString() && key) {
					let characterList = this.characters.systems.euro.categories[key];
					for (let key2 in characterList.content) {
						let unicode = characterList.content[key2].unicode;
						characterList.content[key2].title = String.fromCharCode(unicode);
						result[key2] = characterList.content[key2];
					}
				}
			} else {
				let characterList = this.characters.systems.euro.categories[key];
				for (let key2 in characterList.content) {
					var char = characterList.content[key2]
					let unicode = characterList.content[key2].unicode;
					char.title = String.fromCharCode(unicode);
					char.category = characterList.title
					result[count] = characterList.content[key2];
					count++;
				}
			}
		}
		result = this.sort(result);
		return result;
	}

	getAllCharacters() {
		var result = {};
		for (let key in this.characters.systems.euro.categories) {
			if (key !== "control") {
				let characterList = this.characters.systems.euro.categories[key];
				for (let key2 in characterList.content) {
					let unicode = characterList.content[key2].unicode;
					characterList.content[key2].title = String.fromCharCode(unicode);
					result[key2] = characterList.content[key2];
				}
			}
		}
		return result;
	}

	sort = (list) => {
		var sorted = {};
		let values = Object.values(list);

		//sort values by title
		var sortedValues = values.sort((a, b) => {
			var unicodeA = a.unicode,
				unicodeB = b.unicode;
			if (unicodeA < unicodeB) return -1;
			if (unicodeA > unicodeB) return 1;
			return 0;
		});
		//map sorted array to keys
		Object.keys(list).map((key, i) => {
			sorted[key] = sortedValues[i];
		});
		return sorted;
	}
};